import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';
import { IHttpJsonApiError } from '../../custom-error-handler.service';

export class HttpJsonApiErrorPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(private readonly errorConverter: ErrorConverterService) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        const error: IHttpJsonApiError = packet.data as IHttpJsonApiError;

        if (!error?.error?.errors || !Array.isArray(error.error.errors)) {
            return next(packet);
        }

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromJsonApi(error.error),
        };
    }
}
